import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import {
	StyledContainer,
	StyledCount,
	StyledInfoContainer,
} from './AdminInfo.styled';

const AdminInfo = () => {
	const reportsCount = useObservable(rage.admin.getReportsCount());
	const moderationsCount = useObservable(rage.admin.getModerationsCount());
	const anticheatCount = useObservable(rage.admin.getAnticheatCount());

	if (!reportsCount && !moderationsCount && !anticheatCount) return null;

	return (
		<StyledContainer>
			{reportsCount ? (
				<StyledInfoContainer>
					<StyledCount>
						<Text>{reportsCount}</Text>
					</StyledCount>
					<Text>Репорты</Text>
				</StyledInfoContainer>
			) : null}
			{moderationsCount ? (
				<StyledInfoContainer>
					<StyledCount>
						<Text>{moderationsCount}</Text>
					</StyledCount>
					<Text>Модерация</Text>
				</StyledInfoContainer>
			) : null}
			{anticheatCount ? (
				<StyledInfoContainer>
					<StyledCount $color="#C71E1E">
						<Text>{anticheatCount}</Text>
					</StyledCount>
					<Text>Античит</Text>
				</StyledInfoContainer>
			) : null}
		</StyledContainer>
	);
};

export { AdminInfo };
